import { memo } from 'react'
import { StackedCarouselSlideProps } from 'react-stacked-center-carousel'
import Image from 'next/image'

import { ScrollCardCont } from './style'
import CloseIcon from 'public/assets/gallery/close.svg'

interface IScrollCardProps {
  onRemoveClick?: (item?: any) => void
  nftData: StackedCarouselSlideProps
}

const ScrollCard = (props: IScrollCardProps) => {
  const { nftData, onRemoveClick } = props

  const { data, dataIndex } = nftData

  if (dataIndex >= data.length) return <></>

  const { image } = data[dataIndex]

  return (
    <ScrollCardCont>
      <Image fill draggable={false} src={image} alt='nft-icon' />
      {nftData.isCenterSlide && (
        <Image
          src={CloseIcon}
          alt='close-icon'
          className='close'
          onClick={() => onRemoveClick?.(data[dataIndex])}
        />
      )}
    </ScrollCardCont>
  )
}

export default memo(ScrollCard)
